import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Layout, Row, Col } from "antd";
import { Redirect } from "react-router-dom";
import Sidebar from "./components/menu/Sidebar";
import MenuHeader from "./components/header";
import { getAgedTickets } from "../redux/APMS/Tickets/TicketsActions";
import TicketModal from "../view/APMS/AgedTickets";

const { Content } = Layout;

export default function VerticalLayout(props) {
    const { children } = props;
    const [visible, setVisible] = useState(false);
    const [agedTicketModalvisible, setAgedTicketModalvisible] = useState(false);
    const [agedTicketData, setAgedTicketData] = useState(null);
    const customise = useSelector(state => state.customise);
    const auth = useSelector((state) => state.login);

    useEffect(() => {
        const fetchData = async () => {
            let response = await getAgedTickets({ user: localStorage.getItem("user") });

            if (response.length > 0) {
                setAgedTicketData(response);
                setAgedTicketModalvisible(true);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        const handleStorageChange = (event) => {
            console.log(event.key + " - " + event.newValue);
            if (event.key === 'authenticated' && event.newValue == null) {
                setRedirect(true);
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    return (
        auth.isAuthenticated ? (<Layout className="hp-app-layout">
            <Sidebar visible={visible} setVisible={setVisible} />
            <Layout className="hp-bg-color-dark-90">
                <MenuHeader setVisible={setVisible} className="vertical_header" />
                <Content className="hp-content-main hp-mt-24">
                    <Row justify="center">
                        {customise.contentWidth == "full" && (<Col span={24}>{children}</Col>)}
                        {customise.contentWidth == "boxed" && (<Col xxl={20} xl={22} span={24}>{children}</Col>)}
                    </Row>
                </Content>
            </Layout>
            {/* Ticket Modal */}
            <TicketModal agedTicketModalvisible={agedTicketModalvisible} setAgedTicketModalvisible={setAgedTicketModalvisible} agedTicketData={agedTicketData} />
        </Layout>)
            : <Redirect to="/login" />
    );
};